<div class="empty-state" [ngClass]="'size-' + size" [style.min-height]="minHeight">
  <div class="empty-state-content">
    <div class="empty-state-icon">
      <i [class]="icon"></i>
    </div>
    <h4 class="empty-state-title">{{ title | translate }}</h4>
    <p class="empty-state-text" *ngIf="text">{{ text | translate }}</p>
    <button
      *ngIf="actionLabel"
      type="button"
      class="btn btn-primary btn-lg"
      [disabled]="actionDisabled"
      (click)="action.emit()">
      <!-- El margen va dentro del binding: `[class]` sustituye el atributo entero, así que
           un `class="me-2"` estático al lado se perdería. -->
      <i [class]="actionIcon + ' me-2'"></i>
      {{ actionLabel | translate }}
    </button>
    <ng-content></ng-content>
  </div>
</div>
